import React from 'react';
import PasskeyLoginForm from './components/PasskeyLoginForm.tsx';

const LoginPage: React.FC = () => {
  return <PasskeyLoginForm />;
};

export default LoginPage;
